export default {
  debugShowHiddenCheckbox: {
    margin: '20px 0 0 15px',
  },
};
